import {
  award_method_options,
  award_rows,
  award_status_options,
  bid_committee_options,
  bid_rows,
  bid_status_options,
  category_status_options,
  deviation_rows,
  deviation_status_options,
  deviation_type_options,
  emergency_rows,
  irregularity_cards,
  irregularity_rows,
  irregularity_severity_options,
  irregularity_status_options,
  irregularity_type_options,
  overview_cards,
  plan_rows,
  requisition_eligibility_options,
  requisition_method_options,
  requisition_rows,
  requisition_status_options,
  requisition_threshold_options,
  tabs,
  threshold_rows
} from './procurement_compliance_data';
import {
  create_award_form,
  create_bid_form,
  create_category_form,
  create_deviation_form,
  create_irregularity_form,
  create_requisition_form,
  create_rule_form,
  deep_clone
} from './procurement_compliance_helpers';
import {
  procurement_before_unmount,
  procurement_computed,
  procurement_methods,
  procurement_watch
} from './procurement_compliance_ui';

export default {
  name: 'ComplyonProcurement',
  data: () => ({
    tabs,
    active_tab: 'overview',
    overview_cards,
    plan_rows: deep_clone(plan_rows),
    threshold_rows: deep_clone(threshold_rows),
    requisition_rows: deep_clone(requisition_rows),
    bid_rows: deep_clone(bid_rows),
    award_rows: deep_clone(award_rows),
    deviation_rows: deep_clone(deviation_rows),
    emergency_rows: deep_clone(emergency_rows),
    irregularity_cards,
    irregularity_rows: deep_clone(irregularity_rows),
    category_modal_open: false,
    category_modal_mode: 'create',
    editing_category_key: null,
    category_form: create_category_form(),
    category_status_options,
    threshold_modal_open: false,
    threshold_modal_mode: 'create',
    editing_threshold_key: null,
    threshold_form: create_rule_form(),
    requisition_modal_open: false,
    requisition_modal_mode: 'create',
    editing_requisition_key: null,
    requisition_form: create_requisition_form(),
    requisition_method_options,
    requisition_threshold_options,
    requisition_eligibility_options,
    requisition_status_options,
    active_requisition_drawer: null,
    bid_modal_open: false,
    bid_modal_mode: 'create',
    editing_bid_key: null,
    bid_form: create_bid_form(),
    bid_committee_options,
    bid_status_options,
    award_modal_open: false,
    award_modal_mode: 'create',
    editing_award_key: null,
    award_form: create_award_form(),
    award_method_options,
    award_status_options,
    deviation_modal_open: false,
    deviation_modal_mode: 'create',
    editing_deviation_key: null,
    editing_deviation_source: 'deviation',
    deviation_form: create_deviation_form(),
    deviation_type_options,
    deviation_status_options,
    irregularity_modal_open: false,
    irregularity_modal_mode: 'create',
    editing_irregularity_key: null,
    irregularity_form: create_irregularity_form(),
    irregularity_type_options,
    irregularity_severity_options,
    irregularity_status_options
  }),
  computed: procurement_computed,
  watch: procurement_watch,
  beforeUnmount: procurement_before_unmount,
  methods: procurement_methods
};
